<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Migrasi Bunga Harian
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="savemigrationdata()" :disabled="!saveEnabled">
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="cancel()">
            <i class="fa fa-close"></i> {{$t('cancel')}}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="rekonsil">Rekon Status</b-form-checkbox>
                  <b-form-checkbox value="uraian1">Description Sub Modul</b-form-checkbox>
                  <b-form-checkbox value="uraian2">Description GL</b-form-checkbox>
                  <b-form-checkbox value="nilai1">Value Sub Modul</b-form-checkbox>
                  <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >

        <!-- <template v-slot:thead-top="data">
        <b-tr>
          <b-th colspan="10">
              <span class="sr-only">&nbsp;</span>
            </b-th>
          <b-th variant="success" colspan="3" class="text-center">AKUMULASI PAYMENT / SETTLEMENT</b-th>
          <b-th variant="warning" colspan="3" class="text-center">SALDO/SISA</b-th>
        </b-tr>
      </template> -->
          <template
            v-slot:cell(no_kontrak)="data"
          >
            <span v-if="data.item._cellVariants&&data.item._cellVariants.no_kontrak=='danger'" v-b-tooltip.hover title="No kontrak tidak ada di DATABASE">{{ data.item.no_kontrak}}</span>
            <span v-else>{{ data.item.no_kontrak}}</span>
          </template>
          <template v-slot:cell(tgl_bunga)="data">
            <span v-if="(data.item.tgl_bunga)">{{ data.item.tgl_bunga | moment("DD-MMM-YYYY") }}</span>
          </template>
          <template
            v-slot:cell(nilai_pokok)="data"
          >{{ data.item.nilai_pokok | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(nilai_bunga)="data"
          >{{ data.item.nilai_bunga | numFormat('0,0.00') }}</template>
          
          <template v-slot:custom-foot>
            <b-tr>
              <b-td colspan="3">
                <h6 class="text-right">Total:</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">{{sum_principal | numFormat('0,0.00')}}</h6>
              </b-td>
              <b-td>
                &nbsp;
              </b-td>
              <b-td>
                <h6 class="text-right">{{sum_nilai_bunga | numFormat('0,0.00')}}</h6>
              </b-td>
            </b-tr>
          </template>

        </b-table>
        <b-row class="mt-2">
          <!-- <b-col lg="8">
            <b-row>
              <b-col cols="6">
                <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox>
                Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
              </b-col>
              <b-col cols="6">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
                    <span
                      class="mr-1"
                    >limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col> -->
          <b-col cols="4">
                <!-- <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox> -->
                Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
              </b-col>
              <b-col cols="4">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:center;">
                    <!-- Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries, -->
                    <span
                      class="mr-1"
                    >limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <!-- <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div> -->
                </div>
              </b-col>
          <b-col lg="4">
            <!-- <b-row align-h="right">
              <b-col md="5">
                <b-form-group label="Total Sisa Pokok">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalModul"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group label="Total Sisa Bunga">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalGl"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
            </b-row> -->
            <div>
                    <b-pagination
                      class="ml-1"
                      align="right"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="8">
        <b-card>
          <div slot="header">
            Migrasi Data Bunga Harian
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>

          <b-input-group>
            <b-input-group-prepend>
              <label>Choose *.XLSX file</label>
            </b-input-group-prepend>
            <b-form-file
              v-model="fileXlsx"
              :state="!$v.fileXlsx.$error"
              placeholder="Choose a XLSX file..."
              drop-placeholder="Drop XLSX file here..."
            ></b-form-file>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nama SHEET</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-append>
                  <label class="input-group-text ml-1">Data mulai baris ke-</label>
                </b-input-group-append>
                <b-form-input
                  v-model="frmUpload.startRow"
                  type="number"
                  :state="!$v.frmUpload.startRow.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          <b-col lg="12">
              <b-alert :show="showLabelError" variant="danger" class="mt-4">
                <span v-if="labelErrorTxt!=''">{{labelErrorTxt}}</span>
                <b-list-group flush v-if="errorList && errorList.length>0" style="max-height: 280px;overflow-x: auto;">
                  <b-list-group-item
                    v-for="(item,index) in errorList"
                    :key="index"
                  >Baris : {{item.baris}}, Kolom : {{item.kolom}} , Kesalahan : {{item.message}}</b-list-group-item>
                </b-list-group>
              </b-alert>
            </b-col>
          </b-row>
          <div slot="footer" class="text-center">
            <b-button variant="primary" @click="importmigrationdata()">Import</b-button>
            <b-button variant="danger" @click="close()">Close</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
     <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Konfirmasi"
      v-model="confirmCancel"
      @ok="handleCancel"
    >
        <p class="my-2">Apakah anda yakin?</p>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import klmXls from "../../data/kolomXls"
import migration from "../../apis/migration";
import uploadSet from "../../apis/uploadsetting";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
    },
    fileXlsx: { required }
  },
  data() {
    return {
      showUploadFrm: true,
      fileXlsx: null,
      frmUpload: {
        sheetName: "BUNGA-HARIAN",
        startRow: 10,
        compcode: 'B',
        no_kontrak: 'C',
        tgl_bunga: 'D',
        nilai_pokok: 'E',
        interest: 'F',
        nilai_bunga: 'G'
      },
      showLabelError: false,
      errorList: [],
      labelErrorTxt:'',
      kolomXls: klmXls,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      rptLines: [],
      subtotal: {},
      sum_principal: 0,
      sum_nilai_bunga: 0,
      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          // {
          //   key: "no",
          //   label: "No.",
          //   thClass: "text-center",
          //   tdClass: "text-center",
          //   sortable: true,
          // },
          {
            key: "compcode",
            label: "Kode Entitas",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "no_kontrak",
            label: "No. Kontrak",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "tgl_bunga",
            label: "Tgl Bunga",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nilai_pokok",
            label: "Principal",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "interest",
            label: "Tarif Bunga",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nilai_bunga",
            label: "Nilai Bunga",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
        ],
      },
      filter: null,
      filterOn: [],
      saveEnabled:true,
      confirmCancel:false
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
    invalidFileXlsx() {
      this.$v.fileXlsx.$touch();
      return this.$v.fileXlsx.$invalid;
    },
  },
  watch: {},
  created: async function(){
    let getgroupmigrationkey = localStorage.getItem('groupmigrationbungahariankey');
    let getSheetName = localStorage.getItem('sheetName');
    if(getgroupmigrationkey) {
      this.showUploadFrm = false;
      let res = await migration.getmigrationTEMP(getgroupmigrationkey, getSheetName);
      this.rptLines = res;
      // jika tidak ada data balikan dari DB maka storage dihapus
      if(res.length==0){
        this.showUploadFrm = true;
        localStorage.removeItem("groupmigrationkey");
        localStorage.removeItem("sheetName");
      }
      this.sum(res);
    }
    // Get setting field from DB
    const setting = await uploadSet.get('upload_migrationbungaharian'); 
    for (const key in setting) {
      this.frmUpload[key] = setting[key];
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    sum(result) {
      let sum_principal = 0;
      let sum_nilai_bunga = 0;
      result.map((dt) => {
        sum_principal += dt.principal;
        sum_nilai_bunga += dt.nilai_bunga;
      });
      this.rptLines = result;
      this.sum_principal = sum_principal;
      this.sum_nilai_bunga = sum_nilai_bunga;
      this.showUploadFrm = false;
      this.tblLcy.total = result.length;
      this.isLoading = false;
    },
    async importmigrationdata() {
      if (this.invalidFileXlsx || this.invalidFrmUpload) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.isLoading = true;
          const {list:result,groupmigrationkey} = await migration.savemigrationbungaharianTEMP(this.fileXlsx, this.frmUpload);
          if (result.length==0) {
            toastr.warn("Data is empty");
          } else {
            this.saveEnabled = result.filter(x=>x.error==true).length==0;
            localStorage.setItem('groupmigrationbungahariankey', groupmigrationkey);
            localStorage.setItem('sheetName', 'BUNGA_HARIAN');
          }

          this.sum(result);
          // let sum_principal = 0;
          // let sum_tarifdenda = 0;
          // let sum_nilai_denda = 0;
          // result.map((dt) => {
          //   sum_principal += dt.principal;
          //   sum_tarifdenda += dt.tarifdenda;
          //   sum_nilai_denda += dt.nilai_denda;
          // });
          // this.rptLines = result;
          // this.sum_principal = sum_principal;
          // this.sum_tarifdenda = sum_tarifdenda;
          // this.sum_nilai_denda = sum_nilai_denda;
          // this.showUploadFrm = false;
          // this.tblLcy.total = result.length;
          // this.isLoading = false;

        } catch (error) {
          this.isLoading = false;
          if (error.errSheetList || error.message) {
            this.showLabelError = true;
            this.labelErrorTxt = error.message;
            this.errorList = error.errSheetList;
            this.fileXlsx = null;
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    async savemigrationdata() {
      if (this.rptLines.length==0) {
        toastr.warn("Data is empty");
      } else {
         try {
           this.isLoading = true;
          let getgroupmigrationkey = localStorage.getItem('groupmigrationbungahariankey');
          await migration.savemigrationbungaharian(getgroupmigrationkey);
          this.showUploadFrm = true;
          localStorage.removeItem('groupmigrationbungahariankey');
          localStorage.removeItem('sheetName');
          toastr.success('Data migrasi berhasil disimpan.');
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    },
    cancel(){
      if(!this.saveEnabled){
        this.handleCancel();
      }else{
        this.confirmCancel =!this.confirmCancel;
      }
    },
    async handleCancel(){
      this.showUploadFrm=true;
      this.rptLines=[];
      await migration.removeDataTEMP({
        tablename:'fin_migration_bunga_harian',
        groupmigrationkey:localStorage.getItem("groupmigrationbungahariankey")
      });
      localStorage.removeItem('groupmigrationbungahariankey');
      localStorage.removeItem('sheetName');
    }
  },
};
</script>
